class VideoPlayer extends HTMLElement {
  constructor() {
    super();

    this.video = null;
    this.overlay = null;
    this.toggleButton = null;
    this.playIcon = null;
    this.pauseIcon = null;

    this.handleToggleClick = this.handleToggleClick.bind(this);
    this.handlePlay = this.handlePlay.bind(this);
    this.handlePause = this.handlePause.bind(this);
  }

  connectedCallback() {
    this.video = this.querySelector('[data-video-player-video]');
    this.overlay = this.querySelector('[data-video-player-overlay]');
    this.toggleButton = this.querySelector('[data-video-player-toggle]');
    this.playIcon = this.querySelector('[data-video-player-play-icon]');
    this.pauseIcon = this.querySelector('[data-video-player-pause-icon]');

    if (!this.video || !this.toggleButton) return;

    this.toggleButton.addEventListener('click', this.handleToggleClick);
    this.video.addEventListener('play', this.handlePlay);
    this.video.addEventListener('pause', this.handlePause);
    this.video.addEventListener('ended', this.handlePause);
  }

  disconnectedCallback() {
    if (!this.video || !this.toggleButton) return;

    this.toggleButton.removeEventListener('click', this.handleToggleClick);
    this.video.removeEventListener('play', this.handlePlay);
    this.video.removeEventListener('pause', this.handlePause);
    this.video.removeEventListener('ended', this.handlePause);
  }

  handleToggleClick() {
    if (this.video.paused || this.video.ended) {
      const playPromise = this.video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    } else {
      this.video.pause();
    }
  }

  handlePlay() {
    this.classList.add('is-playing');
    if (this.overlay) this.overlay.classList.add('hidden');
    if (this.playIcon) this.playIcon.classList.add('hidden');
    if (this.pauseIcon) this.pauseIcon.classList.remove('hidden');
    this.toggleButton.setAttribute('aria-label', 'Pause video');
  }

  handlePause() {
    this.classList.remove('is-playing');
    if (this.overlay) this.overlay.classList.remove('hidden');
    if (this.playIcon) this.playIcon.classList.remove('hidden');
    if (this.pauseIcon) this.pauseIcon.classList.add('hidden');
    this.toggleButton.setAttribute('aria-label', 'Play video');
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer);
}
